import { Typography } from "@libs/zapi-ui/custom";
import { cn } from "../../../shared/lib/utils";
import { Button } from "@libs/zapi-ui/shadcn";
interface SidebarProps extends React.HTMLAttributes<HTMLElement> {
  activeTab: "Team" | "Profile" | "General";
  setActiveTab: (tab: "Team" | "Profile") => void;
  menuItems: {
    [key: string]: {
      name: string;
      icon: React.ReactNode;
    }[];
  };
}

export function Sidebar({ className, activeTab, setActiveTab, menuItems }: SidebarProps) {
  return (
    <aside className={cn("w-[260px] border-r", className)}>
      <div className="space-y-4 py-[18px]">
        <div className="px-1">
          <Typography variant="heading6" color="zinc900" className="pl-[14px]">
            Settings
          </Typography>
          <div className="space-y-1">
            {Object.entries(menuItems).map(([section, items]) => (
              <div key={section}>
                <h3 className="mb-1 mt-4 px-4 text-sm font-medium text-muted-foreground">{section}</h3>
                <div className="space-y-1 flex flex-col items-start">
                  {items.map((item) => (
                    <Button
                      key={item.name}
                      onClick={() => setActiveTab(item.name as "Team" | "Profile")}
                      variant="ghost"
                      className={cn("w-full justify-start hover:bg-zinc-200", activeTab === item.name && "bg-zinc-200")}
                    >
                      {item.icon}
                      {item.name}
                    </Button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </aside>
  );
}
